import { Navigate, useLocation } from 'react-router';

const RedirectKeepingSearch = ({ to, from }) => {
    const { pathname, search } = useLocation();

    return <Navigate to={{ pathname: from ? `${to}${pathname.slice(from.length)}` : to, search }} replace />;
};

export default RedirectKeepingSearch;
